import IconArrowUpLong from "@/app/(components)/generics/Icons/IconArrowUpLong";
import IconClaude from "@/app/(components)/generics/Icons/IconClaude";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import {
  connectorDots,
  HOW_CONNECTORS_ANSWER,
  HOW_CONNECTORS_CLIENTS,
  HOW_CONNECTORS_CONTEXT,
} from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";

export default function HowItWorksMockConnectors() {
  const T = useT();

  return (
    <div className={UStyles.classNames(styles.card, styles.aiCard)}>
      <div className={styles.aiBar}>
        <span className={styles.aiTabs}>
          {HOW_CONNECTORS_CLIENTS.map((client, index) => (
            <span
              key={client.name}
              className={UStyles.classNames(styles.aiTab, index === 0 ? styles.aiTabActive : "")}
            >
              <span className={UStyles.classNames(styles.aiTabIcon, styles[client.colorClass])}>
                <client.Icon />
              </span>
              {client.name}
            </span>
          ))}
        </span>
        <span className={styles.aiStatus}>
          <span className={UStyles.classNames(styles.statusDot, styles.won)} />
          {T(TKey.HOME_MEIDLY_HOW_CONNECTORS_CONNECTED)}
        </span>
      </div>

      <span className={styles.prompt}>{T(TKey.HOME_MEIDLY_HOW_CONNECTORS_QUESTION)}</span>

      <div className={styles.aiTurn}>
        <span className={styles.aiAvatar}>
          <IconClaude />
        </span>

        <div className={styles.aiBody}>
          <div className={styles.toolBlock}>
            <span className={styles.toolHead}>
              <span className={styles.label}>{T(TKey.HOME_MEIDLY_HOW_CONNECTORS_TOOL)}</span>
              <span className={styles.toolScan}>{T(TKey.HOME_MEIDLY_HOW_CONNECTORS_SCAN)}</span>
            </span>
            <span className={styles.dotField}>
              {connectorDots().map((dot) => (
                <span
                  key={dot.id}
                  className={UStyles.classNames(
                    styles.fieldDot,
                    dot.dotClass ? styles.fieldDotKept : "",
                    dot.dotClass ? styles[dot.dotClass] : "",
                  )}
                />
              ))}
            </span>
            <span className={styles.toolChips}>
              {HOW_CONNECTORS_CONTEXT.map((item) => (
                <span
                  key={item.labelKey}
                  className={UStyles.classNames(
                    styles.tag,
                    styles.legendTag,
                    styles[item.toneClass],
                  )}
                >
                  <span className={UStyles.classNames(styles.legendDot, styles[item.dotClass])} />
                  {T(item.labelKey)}
                </span>
              ))}
            </span>
            <span className={styles.toolMeta}>{T(TKey.HOME_MEIDLY_HOW_CONNECTORS_TOKENS)}</span>
          </div>

          <div className={styles.draft}>
            <span className={styles.draftHead}>
              <span className={styles.draftSubject}>
                {T(TKey.HOME_MEIDLY_HOW_CONNECTORS_DRAFT_SUBJECT)}
              </span>
            </span>
            <span className={styles.answerText}>
              {HOW_CONNECTORS_ANSWER.map((key) => `${T(key)} `)}
              <span className={styles.caret} />
            </span>
          </div>
        </div>
      </div>

      <div className={styles.askBar}>
        <span className={UStyles.classNames(styles.askText, styles.askPlaceholder)}>
          {T(TKey.HOME_MEIDLY_HOW_CONNECTORS_COMPOSER)}
        </span>
        <span className={styles.askSend}>
          <IconArrowUpLong />
        </span>
      </div>
    </div>
  );
}
